import elementService from "@/common/ElementService";

export default new class FixedEshopHeaderService {
    private readonly headerPosition: number;
    private lastScrollY: number;
    private lastDirectionIsUp: boolean | undefined;
    private lastChangeYPosition: number;

    private readonly headerBottomElement: HTMLDivElement;
    private readonly headerBottomInnerElement: HTMLDivElement;

    constructor() {
        this.headerBottomElement = elementService.querySelector<HTMLDivElement>(".header-bottom");
        this.headerBottomInnerElement = elementService.elementQuerySelector<HTMLDivElement>(this.headerBottomElement, ".header-bottom-inner");
        this.headerPosition = this.headerBottomElement.getBoundingClientRect().top + this.headerBottomElement.getBoundingClientRect().height;
        this.lastScrollY = window.scrollY;
        this.lastChangeYPosition = window.scrollY;
    }

    public init(): void {
        this.initAfterLoadPosition();
        window.addEventListener("scroll", () => this.changeByScrollPosition());
    }

    private initAfterLoadPosition(): void {
        if (window.scrollY >= this.headerPosition) {
            this.headerBottomInnerElement.classList.add("fixed", "animated");
        }
    }

    private changeByScrollPosition(): void {
        const scrollDirectionIsUp = window.scrollY < this.lastScrollY;
        const changeDirectionToUp = scrollDirectionIsUp && !(this.lastDirectionIsUp ?? false);

        if (changeDirectionToUp) {
            this.lastChangeYPosition = window.scrollY;
        } else if (window.scrollY === 0 || !scrollDirectionIsUp) {
            this.removeHoverPosition();
        } else if (window.scrollY >= this.headerPosition && this.lastChangeYPosition - window.scrollY >= 50) {
            this.setHeaderHoverPosition();
        }

        this.lastScrollY = window.scrollY;
        this.lastDirectionIsUp = scrollDirectionIsUp;
    }

    private setHeaderHoverPosition(): void {
        this.headerBottomInnerElement.classList.add("fixed");

        if (window.scrollY > this.lastScrollY) {
            this.headerBottomInnerElement.classList.add("unpin");
            this.headerBottomInnerElement.classList.remove("pin");
        } else {
            this.headerBottomInnerElement.classList.remove("unpin");
            this.headerBottomInnerElement.classList.add("pin", "animated");
        }
    }

    private removeHoverPosition(): void {
        this.headerBottomInnerElement.classList.remove("fixed", "unpin", "pin", "animated");
    }
}();
